'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { Card, CardContent, CardFooter } from '@achra/ui/card';
import { cn } from '@achra/ui/lib/utils';
import { Separator } from '@achra/ui/separator';
import { ArrowRight } from 'lucide-react';
import Link from 'next/link';
import SimpleBar from 'simplebar-react';
import type { BuilderProfileState } from '@/modules/__generated__/graphql/switchboard-generated';
import { BuilderProfile } from '@/modules/shared/components/builder-profile/builder-profile';
import { BuilderSkills } from '@/modules/shared/components/builder-skills';
import { BuildersSkeleton } from '../../builders-skeleton';
import { LastModified } from '../last-modified/last-modified';
import { Links } from '../links';
import { NoBuildersFound } from '../no-builders-found/no-builders-found';
import { useBuildersList } from './use-builders-list';
import type { Route } from 'next';
export interface BuildersListProps {
  builders: BuilderProfileState[];
  networkSlug: string;
  className?: string;
  asSectionContent?: boolean;
}
function BuildersList(t0) {
  const $ = _c(17);
  const {
    builders,
    networkSlug,
    className,
    asSectionContent: t1
  } = t0;
  const asSectionContent = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== asSectionContent || $[1] !== builders) {
    t2 = {
      builders,
      asSectionContent
    };
    $[0] = asSectionContent;
    $[1] = builders;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    simpleBarRef,
    cardContentRef,
    itemsWrapperRef,
    isResetPending,
    isSkillsPending
  } = useBuildersList(t2);
  let t3;
  if ($[3] !== className) {
    t3 = cn("w-full", className);
    $[3] = className;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== asSectionContent || $[6] !== builders || $[7] !== cardContentRef || $[8] !== isResetPending || $[9] !== isSkillsPending || $[10] !== itemsWrapperRef || $[11] !== networkSlug || $[12] !== simpleBarRef) {
    t4 = isResetPending || isSkillsPending ? <BuildersSkeleton /> : builders.length === 0 ? <NoBuildersFound /> : <div ref={cardContentRef}><SimpleBar ref={simpleBarRef} className={cn("-mt-2 pt-2", !asSectionContent && "-mx-2 px-2 pb-2")} autoHide={false}><div ref={itemsWrapperRef} className={cn("flex w-full flex-col gap-2", asSectionContent && "px-2 pb-2")}>{builders.map(builder => <Link href={`/network/${networkSlug}/builders/${builder.slug}` as Route} key={builder.id}><Card className="bg-background w-full gap-2 overflow-hidden border-none pt-2 pb-1"><CardContent className="flex items-end justify-between px-2 md:grid md:grid-cols-[38%_37%_80px]"><BuilderProfile name={builder.name} code={builder.code} status={builder.status} image={builder.icon} isOperator={builder.isOperator} /><div className="hidden flex-col gap-0.5 md:flex"><span className="text-foreground/30 text-sm/5.5 font-semibold">Skills</span><BuilderSkills skills={builder.skills} /></div><div className="flex gap-4 md:gap-2"><Links links={builder.links} /><Button variant="outline" size="icon" aria-label="View builder team details"><ArrowRight className="size-4" /></Button></div></CardContent><CardContent className="flex items-end px-2 md:hidden"><div className="flex flex-col gap-1"><span className="text-foreground/30 text-xs/4.5 font-medium md:text-sm/5.5 md:font-semibold">Skills</span><BuilderSkills skills={builder.skills} /></div></CardContent><Separator className="-mt-0.25" /><CardFooter className="bg-background -mt-1 w-full px-2"><LastModified lastModified={builder.lastModified} isMobile={true} /></CardFooter></Card></Link>)}</div></SimpleBar></div>;
    $[5] = asSectionContent;
    $[6] = builders;
    $[7] = cardContentRef;
    $[8] = isResetPending;
    $[9] = isSkillsPending;
    $[10] = itemsWrapperRef;
    $[11] = networkSlug;
    $[12] = simpleBarRef;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t3 || $[15] !== t4) {
    t5 = <div className={t3}>{t4}</div>;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}
export { BuildersList };